import {Component} from "@angular/core";
import {MatDialogRef} from "@angular/material/dialog";


@Component({
    selector: 'add-eoi-success',
    templateUrl: './success-dialog.component.html',
    styleUrls: ['./success-dialog.component.scss']
})
export class SuccessDialogComponent {

    constructor(
        private dialogRef: MatDialogRef<any>) {

    }

    close() {
        this.dialogRef.close();
    }
}
